
const VisionSection = () => {
  return (
    <section className="py-32 bg-gradient-to-b from-slate-900/30 to-slate-800/30 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-20 right-1/4 w-96 h-96 bg-cyan-600/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 left-1/4 w-80 h-80 bg-blue-600/5 rounded-full blur-3xl"></div>
      </div>

      <div className="relative container mx-auto px-6 max-w-7xl">
        <div className="text-center mb-20">
          <div className="inline-block mb-6">
            <span className="px-4 py-2 bg-cyan-600/20 text-cyan-300 rounded-full text-sm font-medium border border-cyan-400/30">
              Our Vision
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-light text-white mb-8 leading-tight">
            Shaping the <strong className="bg-gradient-to-r from-cyan-400 to-blue-400 bg-clip-text text-transparent">Future</strong>
          </h2>
          <p className="text-lg text-white/80 max-w-3xl mx-auto font-light leading-relaxed">
            To be the leading bridge connecting global innovation ecosystems, empowering businesses worldwide with transformative technology solutions
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16">
          <div className="group relative">
            <div className="absolute inset-0 bg-gradient-to-r from-cyan-600/10 to-blue-600/10 rounded-3xl blur-xl group-hover:blur-2xl transition-all duration-500"></div>
            <div className="relative bg-white/8 backdrop-blur-md border border-white/20 rounded-3xl p-8 hover:bg-white/12 hover:border-cyan-400/40 transition-all duration-500 hover:transform hover:scale-105">
              <div className="w-16 h-16 bg-gradient-to-r from-cyan-400 to-blue-400 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-global-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-semibold text-white mb-4 group-hover:text-cyan-100 transition-colors duration-300">Global Innovation</h3>
              <p className="text-white/70 leading-relaxed font-light">
                Connecting cutting-edge technologies across continents, fostering innovation that transcends geographical boundaries and cultural differences.
              </p>
            </div>
          </div>

          <div className="group relative">
            <div className="absolute inset-0 bg-gradient-to-r from-blue-600/10 to-cyan-600/10 rounded-3xl blur-xl group-hover:blur-2xl transition-all duration-500"></div>
            <div className="relative bg-white/8 backdrop-blur-md border border-white/20 rounded-3xl p-8 hover:bg-white/12 hover:border-blue-400/40 transition-all duration-500 hover:transform hover:scale-105">
              <div className="w-16 h-16 bg-gradient-to-r from-blue-400 to-cyan-400 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-lightbulb-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-semibold text-white mb-4 group-hover:text-blue-100 transition-colors duration-300">Sustainable Solutions</h3>
              <p className="text-white/70 leading-relaxed font-light">
                Developing environmentally conscious technologies that drive progress while preserving our planet for future generations.
              </p>
            </div>
          </div>

          <div className="group relative">
            <div className="absolute inset-0 bg-gradient-to-r from-cyan-600/10 to-blue-600/10 rounded-3xl blur-xl group-hover:blur-2xl transition-all duration-500"></div>
            <div className="relative bg-white/8 backdrop-blur-md border border-white/20 rounded-3xl p-8 hover:bg-white/12 hover:border-cyan-400/40 transition-all duration-500 hover:transform hover:scale-105">
              <div className="w-16 h-16 bg-gradient-to-r from-cyan-400 to-blue-400 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-team-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-semibold text-white mb-4 group-hover:text-cyan-100 transition-colors duration-300">Partnership Excellence</h3>
              <p className="text-white/70 leading-relaxed font-light">
                Building lasting relationships based on trust, innovation, and mutual success with partners across diverse industries and markets.
              </p>
            </div>
          </div>
        </div>

        <div className="text-center">
          <div className="inline-block bg-white/5 backdrop-blur-md border border-white/20 rounded-3xl p-8 max-w-4xl">
            <h3 className="text-2xl font-semibold text-white mb-4">Our Mission</h3>
            <p className="text-lg text-white/80 leading-relaxed font-light">
              To accelerate global technology adoption by providing seamless R&D services, innovative OEM solutions, 
              and strategic technology transfer that empowers businesses to thrive in an interconnected world. 
              We believe that the future belongs to those who can bridge cultures, technologies, and markets with vision and integrity.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VisionSection;
